import React, { useEffect } from 'react';
import { HalfInchEndMillsContent } from '../components/HalfInchEndMillsContent';
import { SiteLayout } from '../components/SiteLayout';
export function SizeTemplatePage() {
  useEffect(() => {
    document.title = '1/2 Inch End Mills | 1/2 Carbide End Mills | 6G Tools.';
  }, []);
  return <SiteLayout data-id="element-1414" data-mp="3nxnfzqdm7bv5"><HalfInchEndMillsContent data-id="element-1415" data-mp="3nxx7jieb5r2y" /></SiteLayout>;
}